import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface UserData {
  id: string;
  email?: string;
  walletAddress: string;
  username: string;
  avatar?: string;
  createdAt: string;
}

interface AuthContextType {
  user: UserData | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: () => void;
  logout: () => void;
  wallets: any[];
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

// 模拟用户数据生成
const generateMockWallet = () => {
  const chars = '0123456789abcdef';
  let address = '0x';
  for (let i = 0; i < 40; i++) {
    address += chars[Math.floor(Math.random() * chars.length)];
  }
  return address;
};

const MOCK_USER: UserData = {
  id: 'mock-user-001',
  email: 'player@rumbleclaw.fun',
  walletAddress: generateMockWallet(),
  username: 'BattleMaster',
  avatar: undefined,
  createdAt: new Date().toISOString(),
};

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // 检查本地存储的登录状态
  useEffect(() => {
    const storedUser = localStorage.getItem('rumbleclaw_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);

  const login = () => {
    // 模拟登录 - 随机生成钱包地址
    const newUser: UserData = {
      ...MOCK_USER,
      walletAddress: generateMockWallet(),
      createdAt: new Date().toISOString(),
    };
    setUser(newUser);
    localStorage.setItem('rumbleclaw_user', JSON.stringify(newUser));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('rumbleclaw_user');
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        isLoading,
        login,
        logout,
        wallets: user ? [{ address: user.walletAddress }] : [],
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
